import { CoreIcon } from '../core-icon';
import errorCircleSVG from '../../assets/icons/error-circle.svg';
import type { IconProps } from '../core-icon';

export const ErrorCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={errorCircleSVG} {...props} />;
};
